import React from "react";
import { TRestaurant, TWorkingHours } from "../types";
import { Avatar, Box, Button, Paper, Typography, useTheme } from "@mui/material";
import { t } from "@lingui/macro";
import { getFixedImageUrl } from "../api";
import dayjs from "dayjs";
import isBetween from 'dayjs/plugin/isBetween';

dayjs.extend(isBetween)

const RestaurantInfo: React.FC<{ restaurant: TRestaurant, workingHours?: TWorkingHours, onReviewsClick?: () => void }> = (props) => {
    const { restaurant, workingHours, onReviewsClick } = props
    const theme = useTheme();

    const isWorking = workingHours?.isWorking
    const hours = workingHours?.hours && workingHours.hours[0]
    const isOpen = hours?.opening && hours?.closing && dayjs().isBetween(dayjs(hours.opening), dayjs(hours.closing))

    return <Paper elevation={1} sx={{ borderRadius: '16px', display: 'flex', flexDirection: 'row', backgroundColor: '#212134' }} >
        <Box display='flex' flexDirection='column' p='16px'>
            <Box p={'8px 0 0 0'}>
                {hours && <>
                    <Typography variant="subtitle1" color={'#ffffff'}>{t`Working hours`}</Typography>
                    <Typography variant="h5" color={'#ffffff'}>
                        {` ${dayjs(hours.opening).format('HH:mm')}-${dayjs(hours.closing).format('HH:mm')}`}
                    </Typography>
                    <Box pb='8px' />
                </>}
                {isWorking && <> {isOpen
                    ? <Typography variant='h5' fontWeight='800' color={theme.palette.success.light}>
                        {t`Open`}
                    </Typography>
                    : <Typography variant='h5' fontWeight='800' color={theme.palette.error.light}>
                        {t`Closed`}
                    </Typography>
                }</>
                }
                <Button sx={{textTransform: 'none'}} variant="text" color="secondary" size="small" onClick={onReviewsClick}>{t`Reviews`}</Button>

            </Box>
        </Box>
        <Box display='flex' flexGrow={1} justifyContent={'end'} alignItems={'center'}>
            <Box sx={{ borderRadius: '50%', padding: '8px', background: 'rgba(255, 255, 255, 0.04)' }}>
                <Box sx={{ borderRadius: '50%', padding: '8px', background: 'rgba(255, 255, 255, 0.06)' }}>
                    <Avatar src={restaurant.imagePath && getFixedImageUrl(restaurant.imagePath)} sx={{ width: '102px', height: '102px' }} />
                </Box>
            </Box>
        </Box>
        <Box></Box>
    </Paper>
}

export default RestaurantInfo;